import React from 'react'

const ArrrivalAndDepartureReportIcon = (props) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M16 29.3327C23.3638 29.3327 29.3333 23.3631 29.3333 15.9993C29.3333 8.63555 23.3638 2.66602 16 2.66602C8.63616 2.66602 2.66663 8.63555 2.66663 15.9993C2.66663 23.3631 8.63616 29.3327 16 29.3327Z" fill="#0057FF" />
            <path d="M20.9467 21.2403C20.7734 21.2403 20.6 21.2003 20.44 21.0937L16.3067 18.627C15.28 18.0137 14.52 16.667 14.52 15.4803V10.0137C14.52 9.46701 14.9734 9.01367 15.52 9.01367C16.0667 9.01367 16.52 9.46701 16.52 10.0137V15.4803C16.52 15.9603 16.92 16.667 17.3334 16.907L21.4667 19.3737C21.9467 19.6537 22.0934 20.267 21.8134 20.747C21.6134 21.067 21.28 21.2403 20.9467 21.2403Z" fill="#0057FF" />
        </svg>

    )
}

export default ArrrivalAndDepartureReportIcon